const Zendesk = require('./zendesk');
const Mixpanel = require('./mixpanel');
const Clarity = require('./clarity');
const GoogleTagManager = require('./gtm');

module.exports = {
	Zendesk,
	Mixpanel,
	Clarity,
	GoogleTagManager,
};
